<div class="userManagementContainer">
  <form [formGroup]="userManagementForm">
    <motif-modal-title class="m_h_5 p_h_5 user-header">
      <div class="headerContainer">
        <motif-icon
          size="30"
          class="motif-icon"
          [iconFunction]="iconCommunity"
        ></motif-icon>
        <!-- <motif-icon [iconFunction]="iconCommunity" strokeWidth="1" stroke="none" class="iconClass" fill="currentColor"
          size="30" title="Computer"></motif-icon> -->
        <div class="header-text">
          <h2 class="header-title">{{ "UserManagement" | translate }}</h2>
        </div>
      </div>
      <button
        motifIconButton
        aria-label="Close modal"
        [motif-modal-close]="true"
        [size]="buttonSizes.LARGE"
      >
        <motif-icon
          class="motif-modal-header-close-icon"
          size="24"
          [iconFunction]="closeIcon"
        ></motif-icon>
      </button>
    </motif-modal-title>
    <motif-modal-content
      [ngClass]="
        currentOption === 1 ? 'user-slide-content' : 'maxHeightContent'
      "
    >
      <p class="sub-header-title">
        {{ "UserManagementSubHeadingMessage" | translate }}
      </p>
      <motif-tab-navigation
        [variant]="variant"
        orientation="horizontal"
        *ngIf="!isIPORModule"
      >
        <button
          motifButton
          [ngClass]="{ 'motif-active': currentOption === 1 }"
          (click)="setTab(1)"
        >
          {{ "Invite" | translate }}
        </button>
        <button
          motifButton
          [ngClass]="{ 'motif-active': currentOption === 2 }"
          (click)="setTab(2); profileHandler()"
        >
          {{ "SharedWithLabel" | translate }}
        </button>
      </motif-tab-navigation>
      @if (currentOption === 1) {
        <div class="pt_14 pb_14">
          <motif-form-field>
            <label motifLabel class="select-label" for="accessTypeField">{{
              "AccessType" | translate
            }}</label>
            <motif-select
              aria-label="Please select the access type"
              labelPosition="outside"
              id="accessTypeField"
              placeholder="{{ 'PleaseSelectTheAccessType' | translate }}"
              formControlName="accessType"
              validationInteraction="touched"
              [disabled]="isExternalUser"
            >
              @for (role of accessType; track role.RoleId) {
                <motif-option [value]="role.RoleId">{{
                  role.RoleName
                }}</motif-option>
              }
            </motif-select>
          </motif-form-field>
        </div>
        <div class="pb_14">
          <motif-form-field>
            <label motifLabel class="select-label" for="addProjectField">{{
              "AddToProjectsLabel" | translate
            }}</label>
            <motif-select
              *ngIf="!isFromProject"
              aria-label="Please select the project"
              labelPosition="outside"
              id="addProjectField"
              placeholder="{{ 'PleaseSelectTheProject' | translate }}"
              formControlName="project"
              validationInteraction="touched"
            >
              @for (project of projectList; track project.ProjectId) {
                <motif-option
                  motif-tooltip="{{ project.ProjectName }}"
                  [hideIconClose]="true"
                  placement="auto"
                  [value]="project"
                  >{{ project.ProjectName }}</motif-option
                >
              }
            </motif-select>
            <input
              *ngIf="isFromProject"
              motifInput
              type="text"
              [readonly]="true"
              aria-label="project name"
              id="projectName"
              labelPosition="outside"
              placeholder="{{ 'ProjectName-PlaceHolder' | translate }}"
              formControlName="projectName"
              validationInteraction="touched"
              autocomplete="off"
            />
          </motif-form-field>
        </div>
        <div class="pb_14">
          <app-user-search
            (selectedUserInfo)="inviteEmailHandler($event)"
            [inlineLabel]="'InviteWithEmailLabel' | translate"
            [labelPosition]="'outside'"
            formControlName="userDetails"
          ></app-user-search>
          <div
            *ngIf="
              userManagementForm.get('userDetails')?.hasError('noEmail') &&
              userManagementForm.get('userDetails')?.touched
            "
            class="error-message"
          >
            {{ "UserMustHaveEmailErrorMessage" | translate }}
          </div>
        </div>
        <div class="userImage">
          <img
            src="assets/images/undraw_swipe-profiles_5koh.svg"
            alt="No record"
          />
        </div>
      } @else {
        <div class="userList">
          <div class="mt_20 searchContainer">
            <motif-form-field>
              <input
                motifInput
                motifSearch
                type="text"
                hideClearButton="false"
                labelPosition="outside"
                placeholder="Search"
                aria-label="Search Bar"
                (input)="searchFilterHandler($event.target.value)"
                (clear)="clearValue()"
              />
            </motif-form-field>
          </div>
          <div class="user-table">
            <motif-table
              [columnDefs]="userColDef"
              [rowData]="rowData"
              [rowHeight]="30"
              [gridOptions]="gridOptions"
              (gridReady)="handleGridReady($event)"
              [pagination]="true"
              [paginationPageSize]="currentlySelectedPageSize.value"
              [paginationSelectTemplate]="paginationSelectTemplate"
            ></motif-table>
          </div>

          <ng-template #paginationSelectTemplate>
            <motif-pagination-select
              label="Per page"
              [selected]="currentlySelectedPageSize"
              [options]="paginationSelectList"
              (change)="updatePaginationSize($event.value)"
            ></motif-pagination-select>
          </ng-template>
        </div>
      }
    </motif-modal-content>

    @if (currentOption === 1) {
      <hr class="break-line" />
      <motif-modal-actions>
        <button
          motifButton
          color="secondary"
          [motif-modal-close]="true"
          (keydown.enter)="$event.preventDefault(); $any($event.target).click()"
          (keydown.space)="$event.preventDefault(); $any($event.target).click()"
          aria-label="Install"
        >
          {{ "Cancel" | translate }}
        </button>
        <button
          motifButton
          color="primary"
          type="submit"
          (click)="inviteFormHandler()"
          [disabled]="!userManagementForm.valid"
        >
          {{ "Invite" | translate }}
        </button>
      </motif-modal-actions>
    }
  </form>
</div>
